/*
 * BCM-737: resolves an opaque "View PO" email deep-link token into the PO
 * dashboard it was issued for.
 *
 * The Daily PO Update email's "View PO" link no longer carries poNumber/tab
 * directly - it carries only this single-use token (see
 * njm-corda-pcmp/repositories/navigationTokenRepo.js), so no PO/business data
 * ever appears in the email itself or in mail-scanner / proxy logs. Once the
 * token is resolved server-side, this component hands off to the existing,
 * unmodified PO dashboard via the same ?poNumber=&tab= query shape it has
 * always used - so nothing about PurchaseOrderDashboard/PurchaseOrderTabTable
 * needs to change for this to work.
 */
import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import axios from "axios";
import { CircularProgress } from "@material-ui/core";
import { appUrl } from "../../../../../utils/config";

const getBase = () =>
  `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}`;

const ViewPoResolver = () => {
  const { roleName, organizationName, ecosystemId, token } = useParams();
  const history = useHistory();
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    const tokenPrefix = token ? `${token.slice(0, 8)}…` : "(none)";
    console.log(`[ViewPoResolver] resolving navigation token ${tokenPrefix}`);

    axios
      .get(`${getBase()}/resolveNavigationToken/${token}`)
      .then((res) => {
        if (res.data && res.data.status === true && res.data.data) {
          const { poNumber, tab } = res.data.data;
          console.log(
            `[ViewPoResolver] token ${tokenPrefix} resolved — poNumber=${poNumber}, tab=${tab || "default"}`
          );
          const query = tab
            ? `?poNumber=${encodeURIComponent(poNumber)}&tab=${encodeURIComponent(tab)}`
            : `?poNumber=${encodeURIComponent(poNumber)}`;
          history.replace(
            `/pcmp/cmo/${encodeURIComponent(roleName)}/${encodeURIComponent(
              organizationName
            )}/${ecosystemId}/purchaseorderManagement${query}`
          );
        } else {
          console.error(
            `[ViewPoResolver] token ${tokenPrefix} rejected —`,
            res.data && res.data.errorMessage
          );
          setErrorMessage(
            (res.data && res.data.errorMessage) || "This link is no longer valid."
          );
        }
      })
      .catch((err) => {
        console.error(`[ViewPoResolver] token ${tokenPrefix} resolve failed —`, err);
        setErrorMessage(
          (err.response && err.response.data && err.response.data.errorMessage) ||
            "This link is no longer valid."
        );
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  if (errorMessage) {
    return (
      <div style={{ textAlign: "center", marginTop: "15%" }}>
        <p>{errorMessage}</p>
        <a
          href={`/pcmp/cmo/${encodeURIComponent(roleName)}/${encodeURIComponent(
            organizationName
          )}/${ecosystemId}/purchaseorderManagement`}
        >
          Go to Purchase Orders
        </a>
      </div>
    );
  }

  return (
    <div style={{ textAlign: "center", marginTop: "25%" }}>
      <CircularProgress color="primary" thickness={7} />
    </div>
  );
};

export default ViewPoResolver;
